import { useState } from "react";
import { useParams } from "react-router-dom";
import { IonRow, IonCol } from "@ionic/react";
import { Loading, SEO } from "../components";
import {
  useReleaseDetails,
  useSpotifyAccessToken,
} from "../hooks/useReleaseData";

export const ReleaseDetails = ({ project }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const accessToken = useSpotifyAccessToken();

  const release = useReleaseDetails(id, accessToken);
  // const currentURL = window.location.href;

  const title = `${release?.name} by ${release?.artists
    ?.map((artist) => artist?.name)
    .join(", ")} – Official Release`;

  const description =
    release?.description ||
    `${release?.name} by ${release?.artists
      ?.map((artist) => artist?.name)
      .join(", ")}. Available now on all streaming platforms.`;

  const keywords = `${release?.name}, ${release?.artists
    ?.map((artist) => artist?.name)
    .join(", ")}, ${release?.genres?.join(
    ", "
  )}, electronic music, release, psybient, progressive chill out, psychedelic, downtempo, electronica, cosmicleaf records, tweak peak records, psychill, chillgressive`;

  const embedUrl = `https://open.spotify.com/embed/album/${id}?utm_source=generator&theme=0`;

  return (
    <div id="DetailsPage" className="details-page">
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        ogImage={`/assets/og_image/${project}.jpg`}
      />
      {loading && <Loading />}

      <IonCol className="details-frame-col">
        <IonRow>
          <iframe
            title={release?.name}
            src={embedUrl}
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="eager"
            decoding="async"
            fetchpriority="high"
            onLoad={() => setLoading(false)}
          />
        </IonRow>
        {/* <IonRow>
          <ShareComponent currentURL={currentURL} />
        </IonRow> */}
      </IonCol>
    </div>
  );
};
